import { Input } from '../ui/Input';
import { MaskedInput } from '../ui/MaskedInput';
import { DateField } from './DateField';
import { maskPassportSeries, maskPassportNumber } from '../../utils/masks';
import type { ClientData } from '../../types/wizard.types';

interface Props {
  client: ClientData;
  update: <K extends keyof ClientData>(k: K, v: ClientData[K]) => void;
}

export function PassportFields({ client, update }: Props) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <MaskedInput
        label="Серия паспорта *"
        value={client.passportSeries}
        mask={maskPassportSeries}
        onValueChange={(v) => update('passportSeries', v)}
        placeholder="__ __"
        inputMode="numeric"
      />
      <MaskedInput
        label="Номер паспорта *"
        value={client.passportNumber}
        mask={maskPassportNumber}
        onValueChange={(v) => update('passportNumber', v)}
        placeholder="______"
        inputMode="numeric"
      />
      <Input
        label="Кем выдан *"
        value={client.passportIssuedBy}
        onChange={(e) => update('passportIssuedBy', e.target.value)}
        className="md:col-span-2"
      />
      <DateField
        label="Дата выдачи"
        value={client.passportIssuedDate}
        onChange={(v) => update('passportIssuedDate', v)}
        required
      />
    </div>
  );
}
